import { SupabaseClient } from "@supabase/supabase-js";
import { Database } from "../database.types";

export type RunWithAssociations = NonNullable<Awaited<ReturnType<typeof fetchRunWithAssociations>>>;

export default async function fetchRunWithAssociations (client: SupabaseClient<Database>, id: string) {
  const {
    data,
  } = await client.from("runs")
    .select(`*, 
      court:courts(*), 
      crews(*, players(*)), 
      statuses(*, player:players(*)),
      sub_requests(*, player:players(*), run_invite:run_invites(*, player:players(*))),
      season:seasons(*, players(*)),
      awards:run_awards(*),
      reviews:run_reviews(*, award_votes(*)),
      award_winners:run_award_winners(*, award:awards(*))
    `)
    .eq("id", id)
    .limit(1)
    .maybeSingle()
    .throwOnError();

  return data;
}
